import {
  FaStar,
  FaGlobe,
  FaAward,
  FaCrown,
  FaMedal,
  FaUserCheck,
  FaCameraRetro,
  FaMapMarkedAlt,
  FaCompass,
  FaGem,
  FaHeart,
  FaTrophy,
  FaHandshake,
  FaUsers,
} from 'react-icons/fa';

export const BADGE_ICONS = {
  profile_starter: {
    icon: <FaUserCheck />,
    color: 'linear-gradient(135deg, #FF6B6B, #FFE66D)',
    border: '#FFE66D',
    shadow: 'rgba(255, 107, 107, 0.4)',
  },
  profile_pro: {
    icon: <FaCameraRetro />,
    color: 'linear-gradient(135deg, #00F5A0, #00D9F5)',
    border: '#00F5A0',
    shadow: 'rgba(0, 245, 160, 0.4)',
  },
  profile_master: {
    icon: <FaGem />,
    color: 'linear-gradient(135deg, #7F00FF, #E100FF)',
    border: '#E100FF',
    shadow: 'rgba(127, 0, 255, 0.4)',
  },
  global_starter: {
    icon: <FaMapMarkedAlt />,
    color: 'linear-gradient(135deg, #0061ff, #60efff)',
    border: '#60efff',
    shadow: 'rgba(0, 97, 255, 0.4)',
  },
  global_explorer: {
    icon: <FaCompass />,
    color: 'linear-gradient(135deg, #1CB5E0, #000851)',
    border: '#1CB5E0',
    shadow: 'rgba(28, 181, 224, 0.4)',
  },
  global_master: {
    icon: <FaGlobe />,
    color: 'linear-gradient(135deg, #000428, #004e92)',
    border: '#004e92',
    shadow: 'rgba(0, 78, 146, 0.4)',
  },
  service_starter: {
    icon: <FaMedal />,
    color: 'linear-gradient(135deg, #F9D423, #FF4E50)',
    border: '#F9D423',
    shadow: 'rgba(249, 212, 35, 0.4)',
  },
  service_pro: {
    icon: <FaAward />,
    color: 'linear-gradient(135deg, #FF512F, #F09819)',
    border: '#F09819',
    shadow: 'rgba(255, 81, 47, 0.4)',
  },
  service_master: {
    icon: <FaCrown />,
    color: 'linear-gradient(135deg, #FFD700, #FFA500)',
    border: '#FFD700',
    shadow: 'rgba(255, 215, 0, 0.4)',
  },
  loved_starter: {
    icon: <FaHeart />,
    color: 'linear-gradient(135deg, #FF0844, #FFB199)',
    border: '#FFB199',
    shadow: 'rgba(255, 8, 68, 0.4)',
  },
  loved_pro: {
    icon: <FaStar />,
    color: 'linear-gradient(135deg, #FF0099, #FF6A00)',
    border: '#FF6A00',
    shadow: 'rgba(255, 0, 153, 0.4)',
  },
  loved_master: {
    icon: <FaTrophy />,
    color: 'linear-gradient(135deg, #FFE259, #FFA751)',
    border: '#FFE259',
    shadow: 'rgba(255, 226, 89, 0.4)',
  },
  invitation_starter: {
    icon: <FaHandshake />,
    color: 'linear-gradient(135deg, #00C6FB, #005BEA)',
    border: '#00C6FB',
    shadow: 'rgba(0, 198, 251, 0.4)',
  },
  invitation_pro: {
    icon: <FaUsers />,
    color: 'linear-gradient(135deg, #3C8CE7, #00EAFF)',
    border: '#00EAFF',
    shadow: 'rgba(60, 140, 231, 0.4)',
  },
  invitation_master: {
    icon: <FaCrown />,
    color: 'linear-gradient(135deg, #FFAA00, #FBDA61)',
    border: '#FBDA61',
    shadow: 'rgba(255, 170, 0, 0.4)',
  },
};
